import { Medicament } from "./medicament";
import { Consultation } from "./consultation";

export class Ophtalmo {
        ophtalmo_id  : any ;
     ophtalmo_droite_sphere : String ;
     ophtalmo_droite_cylindre : String ;
     ophtalmo_droite_axe : String ;
     ophtalmo_droite_add : String ;
     ophtalmo_droite_av : String ;
     ophtalmo_gauche_sphere : String ;
     ophtalmo_gauche_cylindre : String ;
     ophtalmo_gauche_axe : String ;
     ophtalmo_gauche_add : String ;
     ophtalmo_gauche_av : String ;
     ophtalmo_verre_monture : String ;
     ophtalmo_organique : String ;
     ophtalmo_minerale : String ;
     ophtalmo_polycarbonate : String ;
     ophtalmo_blanc : String ;
     ophtalmo_teinte : String ;
     ophtalmo_anti_reflets : String ;
     ophtalmo_photochromique : String ;
     ophtalmo_legerement_teinte : String ;
     ophtalmo_simple_vision : String ;
     ophtalmo_double_foyer : String ;
     ophtalmo_progressif : String ;
         ophtalmo_sans_correction: String ;
    ophtalmo_avec_correction: String;
    ophtalmo_examen_bio: String;
    ophtalmo_auto_refraction: String;
    ophtalmo_subjectif: String;
     consultation_id : any ;

        

    constructor(){
           
    }
}
